import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { RadioButton } from "primereact/radiobutton";
import { PATTERN_LENGTH_OPTIONS, PatternQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The two pattern dials (ADR 0032 §5).
 *
 * Length is the difficulty dial: a longer sequence gives more terms to read
 * the step from, but also puts the gap further from an end. There is no
 * "largest number" setting - what a pattern is built from follows from its
 * kind and its length.
 */
export function PatternSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleQuestionChange(value: PatternQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...settings, PatternQuestion: value });
    }

    function handleLengthChange(event) {
        setSettings({ ...settings, PatternLength: Number(event.target.value) });
    }

    return (
        <div className="patternSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.PatternQuestion}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(PatternQuestionOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.patternTypeAria')}
                />
            </div>
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.termsShownLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.termsShownAria')}>
                {PATTERN_LENGTH_OPTIONS.map((option) => (
                    <div key={option}>
                        <RadioButton
                            inputId={`patternLength-${option}`}
                            value={option}
                            checked={settings.PatternLength === option}
                            onChange={handleLengthChange}
                        />
                        <label htmlFor={`patternLength-${option}`}>{option}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PatternSettings;
